import { create } from "zustand"
import { ROUTE } from "@constants"

type TemporaryProduct = { quantity: number }

type ProductPrintInfo = {
  id: number
  quantity: number
}

type AdvertisementVideoControl = {
  muteAdvertisementVideo: () => void
  unmuteAdvertisementVideo: () => void
}

type SignageState = {
  clientId: number | null
  temporaryProducts: Record<number, TemporaryProduct>
  interactiveProductId: number | null
  productPrintInfo: ProductPrintInfo | null
  advertisementVideoControl: AdvertisementVideoControl | null
  isProductDetailModalOpening: boolean | null
  activeTab: string
  activeMakerId: string | null
  activeTagId: string | null
  actions: {
    setActiveTab: (tab: string, options?: { makerId?: string | null; tagId?: string | null }) => void
    setClientId: (id: number) => void
    setInteractiveProductId: (id: number | null) => void
    closeProductDetailModal: () => void
    setProductPrintInfo: (info: ProductPrintInfo | null) => void
    setTemporaryProduct: (product: Record<number, TemporaryProduct>) => void
    removeTemporaryProduct: (id: number | null) => void
    removeAllTemporaryProducts: () => void
    setAdvertisementVideoControl: (control: AdvertisementVideoControl | null) => void
  }
}

const useSignageStore = create<SignageState>((set, getState) => ({
  clientId: null,
  temporaryProducts: {},
  interactiveProductId: null,
  productPrintInfo: null,
  advertisementVideoControl: null,
  isProductDetailModalOpening: null,
  activeTab: ROUTE.SIGNAGE_PRODUCTS_TOP,
  activeMakerId: null,
  activeTagId: null,
  actions: {
    setActiveTab: (tab, options) => {
      set({ 
        activeTab: tab, 
        activeMakerId: options?.makerId ?? null, 
        activeTagId: options?.tagId ?? null 
      })
    },
    setClientId: (id) => set({ clientId: id }),
    setInteractiveProductId: (id) => set({ interactiveProductId: id, isProductDetailModalOpening: true }),
    closeProductDetailModal: () => set({ isProductDetailModalOpening: false }),
    setTemporaryProduct: (product) => {
      set({ temporaryProducts: Object.assign({}, getState().temporaryProducts, product) })
    },
    setProductPrintInfo: (info: ProductPrintInfo | null) => set({ productPrintInfo: info }),
    removeTemporaryProduct: (id: number | null) => {
      if (!id) return

      const temporaryProducts = getState().temporaryProducts

      delete temporaryProducts[id]
      set({ temporaryProducts: temporaryProducts })
    },
    removeAllTemporaryProducts: () => {
      set({ temporaryProducts: {} })
    },
    setAdvertisementVideoControl: (control) => set({ advertisementVideoControl: control }),
  },
}))

export { useSignageStore }
